<template>
  <q-btn
    v-if="isGranted('DELETE_CLIENT')"
    icon="fa fa-trash"
    label="Delete"
    title="Delete client"
    v-bind="$attrs"
    no-caps
    @click="openModal" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import isGranted from '@/auth/isGranted';
import { Client } from '@/type';
import openModal from '@/components/modal';
import DeleteClientModal from './DeleteClientModal.vue';

export default defineComponent({
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { client: _.cloneDeep(this.client) };
      openModal(DeleteClientModal, props);
    },
    isGranted,
  },
});
</script>
